import {
    AmountsWithTransferSummaryModel,
    MulticurrencyModel,
    TransferSummaryModel
} from './Models/AmountsWithTransferSummaryModel';

import TransferSummary from './general/amount/transferSummary';
import Amounts from './general/amount/amounts';
import { fmComponentsContainer } from './../topic-components';

export default {
    name: "AmountsWithTransferSummary",
    template: "#amounts-with-transfer-summary",
    data: function () {
        return {
            TransferSummaryModel: {} as TransferSummaryModel,
            GeneralErrors: {},
            SenderMulticurrencyModel: {} as MulticurrencyModel,
            ReceiverMulticurrencyModel: {} as MulticurrencyModel,
            Sku: "",
            TransferHeader: "",
            RegulatoryInfo: "",
            IsQuickRegistrationRequired: true,
            IsRedirectToTransferPageRequired: false,
            FetchInitialDataReady: false,
            componentStyle: "",
            Urls: {
                UpdateCurrencyUrl: "/vue/components/amounts/multicurrency",
                FetchInitialDataUrl: "/vue/components/amounts/fetch"
            }
        }
    },
    props: {
        initialSku: String,
        senderCurrency: String,
        header: String,
        componentType: String,

    },
    components: {
        "TransferSummary": TransferSummary,
        "Amounts": Amounts,
    },
    beforeMount() {
        this.requestVerificationToken = document.getElementsByName("__RequestVerificationToken")[0];
    },
    mounted() {
        this.fetchInitialData();
    },
    computed: {
        AmountComponentClass: function () {

            if (this.componentType == "Amount")
                return "s12 m6 l6";

            if (this.componentType == "AmountMini")
                return "s12 m12 l12";

            if (this.componentType == "AmountSmall")
                return "s12 m12 l12";

            return "s12 m6 l6";

        },
        TransferComponentClass: function () {

            if (this.componentType == "Amount")
                return "s12 m6 l6";

            if (this.componentType == "AmountSmall")
                return "s12 m12 l12";

            return "";
        },
        ShowTransferSummary: function () {

            if (this.componentType == "Amount")
                return true;

            if (this.componentType == "AmountSmall")
                return true;

            if (this.componentType == "AmountMini")
                return false;
        }
    },
    methods: {
        async fetchInitialData() {

            if (this.Urls.FetchInitialDataUrl) {
                await fetch(this.Urls.FetchInitialDataUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        senderCurrency: this.senderCurrency,
                        sku: this.initialSku
                    })
                })
                    .then(response => {
                        if (response.ok)
                            return response.json();
                        else
                            throw new Error(`HTTP error! Status: ${response.status}, ${response.statusText}`);

                    })
                    .then(response => {
                        if (response.Errors) {
                            this.GeneralErrors = response.Errors;
                        } else {
                            this.TransferSummaryModel = response.TransferSummaryModel;
                            this.SenderMulticurrencyModel = response.SenderMulticurrencyModel;
                            this.ReceiverMulticurrencyModel = response.ReceiverMulticurrencyModel;
                            this.Sku = response.Sku;
                            this.TransferHeader = response.TransferHeader;
                            this.RegulatoryInfo = response.RegulatoryInfo;
                            this.IsQuickRegistrationRequired = response.IsQuickRegistrationRequired;
                            this.IsRedirectToTransferPageRequired = response.IsRedirectToTransferPageRequired;

                            this.FetchInitialDataReady = true;

                            this.handleInitialDataUpdated();
                        }
                    })
                    .catch(error => {
                        console.error('amountsWithTransferSummary, fetchInitialData()', error);
                        this.removeComponentPreloader();
                    });
            }
        },
        handleInitialDataUpdated() {
            if (this.FetchInitialDataReady) {
                this.removeComponentPreloader();
                //  this.$refs.amountsWithTransferSummaryComponent.style.display = "block";
                this.showComponent();
            }
        },
        handleAmountUpdated: function (senderAmount: number, totalSenderAmount: number, receiverAmount: number) {
            this.TransferSummaryModel.AmountSent = senderAmount;
            this.TransferSummaryModel.TotalChargedAmount = totalSenderAmount;
            this.TransferSummaryModel.AmountReceivable = receiverAmount;

        },
        handleSenderCurrencyUpdated: function (model: AmountsWithTransferSummaryModel) {
            this.TransferSummaryModel = model.TransferSummaryModel;
            this.ReceiverMulticurrencyModel = model.ReceiverMulticurrencyModel;
        },
        handleReceiverCurrencyUpdated: function (model: AmountsWithTransferSummaryModel) {

            this.TransferSummaryModel = model.TransferSummaryModel;
            this.SenderMulticurrencyModel = model.SenderMulticurrencyModel;
            this.TransferHeader = model.TransferHeader;
            this.Sku = model.Sku;
            this.IsRedirectToTransferPageRequired = model.IsRedirectToTransferPageRequired;
        },
        removeComponentPreloader: function () {

            var parent = this.$refs.amountsWithTransferSummaryComponent.parentElement;

            const preloader = parent.querySelector('.component-preloader');

            if (preloader)
                preloader.remove();
        },
        showComponent() {
            this.componentStyle = "display:block";
        },
    }
}

document.onclick = function (event) {
    const classList = (event.target as any).classList;

    const currencyClasses = ["arrowImg", "search_input_dropdown", "dropdown", "displayCurrency", "displayFlag"];

    const isCurrencyCtrl = currencyClasses.some(className => classList.contains(className));

    if (!isCurrencyCtrl)
        fmComponentsContainer.$emit('closeDropdrownMulticurrencyCtrl');
};